import { useSelector } from 'react-redux';
import { RootState } from '../../../states/reducers';
import { dateFormat } from '../../../helpers';
import clsx from 'clsx';

export const Repayments = () => {
  const { loanRepayments } = useSelector((state: RootState) => state.loanRepayment);
  return (
    <>
      {loanRepayments && loanRepayments.length > 0 ? (
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bolder text-muted border-tr'>
                <th className='min-w-100px rounded-start'>Amount</th>
                <th className='min-w-100px'>Status</th>
                <th className='min-w-100px'>Due</th>
                <th className='min-w-100px'>Paid Date</th>
                <th className='text-end rounded-end'></th>
              </tr>
            </thead>
            <tbody>
              {loanRepayments.map((repayment) => (
                <tr key={repayment.id}>
                  <td>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex justify-content-start flex-column'>
                        <div className='text-dark fw-bold text-hover-primary mb-1 fs-7 text-capitalize'>{`${parseFloat(repayment.amount).toLocaleString()}`}</div>
                      </div>
                    </div>
                  </td>
                  <td className='align-top'>
                    <span className={clsx('badge fs-7 fw-bold', repayment.paid ? 'badge-light-success' : 'badge-light-warning')}>{repayment.paid ? 'Paid' : 'Pending'}</span>
                  </td>
                  <td className='align-top'>
                    <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-7'>{dateFormat(repayment.due_date)}</span>
                  </td>
                  <td className='align-top'>
                    <span className='text-dark fw-bold d-block mb-1 fs-7'>{repayment.paid ? dateFormat(repayment.updated_at) : 'N/A'}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div>
          <div className='d-flex justify-content-center align-item-center'>
            <div className='text-center pt-20 pb-20'>
              <i className='bi bi-folder' style={{ fontSize: '3.5em' }}></i>
              <p className='text-muted ms-20p me-20p pt-3 pb-3'>There are no repayments at the moment</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
